// eslint-disable-next-line angular/window-service
export const cacheObjects = window.cacheObjects ?? (window.cacheObjects = {});
